module.exports = __webpack_public_path__ + "static/media/your-music-and-people.7244b238.png";